import { render, staticRenderFns } from "./ActGeometry__addBlock.vue?vue&type=template&id=5ad8c41a&scoped=true&"
import script from "./ActGeometry__addBlock.vue?vue&type=script&lang=js&"
export * from "./ActGeometry__addBlock.vue?vue&type=script&lang=js&"
import style0 from "./ActGeometry__addBlock.vue?vue&type=style&index=0&id=5ad8c41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad8c41a",
  null
  
)

export default component.exports